import { getNethpHref } from "@jdhfe/seouifuncs/dist/tools/getNethpHref";
import styles from "../index.less";
import { targetLink } from "utils";

const HospitalNav = ({ navList }: any) => {
  if (!navList) {
    return null;
  }
  const onClickhref = async (url: any) => {
    targetLink(url);
  };
  return (
    <div className={styles.mainNavBar}>
      <ul>
        {navList?.map((item: any) => {
          let isActive = item.reg
            ? item.reg?.test(window.location.pathname)
            : false;
          if (!isActive && item.url) {
            if (item.url) {
              let _pathName;
              if (item.url.startsWith("http")) {
                const _url = new URL(item.url);
                _pathName = _url.pathname;
              } else {
                _pathName = item.url;
              }
              if (_pathName === window.location.pathname) {
                isActive = true;
              }
            }
          }
          return (
            <li
              className={`${isActive ? styles.activenav : null}`}
              onClick={() => {
                onClickhref(item.url);
              }}
              key={item.url}
            >
              <span data-a-nofollow={item.nofollow} data-a-href={item.url}>
                {item.name || item.title}
              </span>
              <i />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
export default HospitalNav;
